import { Tag, TagMap } from '../../../../../../../common/tags/tagTypes';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectTags, selectTagPaths } from '../../../../../../element/tags/tagSelectors';
import { UseTagPopupsStateReturn } from '../tagComponentPropTypes';

const useTagPopupsState = (toggleEditMenu: (isOpen: boolean) => void): UseTagPopupsStateReturn => {
    const [currentlyEditingTagId, setCurrentlyEditingTagId] = useState<string | null>(null);
    const [showMoveMenu, setShowMoveMenu] = useState<boolean>(false);
    const [showColorChange, setShowColorMenu] = useState<boolean>(false);

    const rootPaths = useSelector(selectTagPaths);
    const { userRootPath, shareRootPath, contextRootsInCurrentPath } = rootPaths || {};

    const tags: TagMap | undefined = useSelector(selectTags);
    const currentlyEditingTag = tags?.[currentlyEditingTagId || ''] || null;

    const allTags = Object.values(tags || {});

    const handleClickEdit = (tag: Tag) => {
        const isOpeningPopup = currentlyEditingTagId !== tag.id;
        setCurrentlyEditingTagId(isOpeningPopup ? tag.id : null);
        toggleEditMenu(isOpeningPopup);
        if (currentlyEditingTagId !== tag.id) {
            setShowMoveMenu(false);
            setShowColorMenu(false);
        }
    };

    const handleClickMoveMenu = () => {
        setShowMoveMenu(!showMoveMenu);
        setShowColorMenu(false);
    };

    const handleClickColorChange = () => {
        setShowColorMenu(!showColorChange);
        setShowMoveMenu(false);
    };

    return {
        allTags,
        currentlyEditingTag,
        setCurrentlyEditingTagId,
        userRootPath,
        shareRootPath,
        handleClickEdit,
        showMoveMenu,
        handleClickMoveMenu,
        showColorChange,
        handleClickColorChange,
        contextRootsInCurrentPath,
    };
};

export default useTagPopupsState;
